import {createIcon} from '@chakra-ui/react'

export const MarmaladeLogoInCircleIcon = createIcon({
  displayName: 'MarmaladeLogoInCircleIcon',
  viewBox: '0 0 65 65',
  path: (
    <>
      <circle cx="32.0585" cy="32.0585" r="32.0585" fill="#1A1A1A" />
      <g clipPath="url(#clip0_126_1869)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.5113 40.8644C27.5113 41.0557 27.3759 41.2106 27.2088 41.2106H20.7049C20.5378 41.2106 20.4023 41.0557 20.4023 40.8644V39.9509C20.4023 39.7959 20.4927 39.6606 20.6217 39.6134C23.4144 38.5945 25.4372 35.6006 25.4372 32.066C25.4372 28.5314 23.4144 25.5376 20.6217 24.5185C20.4927 24.4715 20.4023 24.3361 20.4023 24.1811V23.3778C20.4023 23.1865 20.5378 23.0315 20.7049 23.0315L27.2088 23.0315C27.3759 23.0315 27.5113 23.1865 27.5113 23.3778V40.8644ZM35.6638 40.8644C35.6638 41.0557 35.5283 41.2106 35.3612 41.2106H28.8573C28.6902 41.2106 28.5548 41.0557 28.5548 40.8644V39.9509C28.5548 39.7959 28.6451 39.6606 28.7741 39.6134C31.5669 38.5945 33.5896 35.6006 33.5896 32.066C33.5896 28.5314 31.5669 25.5376 28.7741 24.5185C28.6451 24.4715 28.5548 24.3361 28.5548 24.1811V23.3778C28.5548 23.1865 28.6902 23.0315 28.8573 23.0315L35.3612 23.0315C35.5283 23.0315 35.6638 23.1865 35.6638 23.3778V40.8644ZM43.5122 41.2106C43.6794 41.2106 43.8148 41.0557 43.8148 40.8644V23.3778C43.8148 23.1865 43.6794 23.0315 43.5122 23.0315L37.0083 23.0315C36.8413 23.0315 36.7059 23.1865 36.7059 23.3778V24.1811C36.7059 24.3361 36.7962 24.4715 36.9251 24.5185C39.7179 25.5376 41.7406 28.5314 41.7406 32.066C41.7406 35.6006 39.7179 38.5945 36.9251 39.6134C36.7962 39.6606 36.7059 39.7959 36.7059 39.9509V40.8644C36.7059 41.0557 36.8413 41.2106 37.0083 41.2106H43.5122Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_126_1869">
          <rect
            width="23.5532"
            height="18.3191"
            fill="white"
            transform="translate(20.2812 22.8989)"
          />
        </clipPath>
      </defs>
    </>
  ),
})
